import { Component, OnDestroy, OnInit } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { fadeInRightAnimation } from "src/@fury/animations/fade-in-right.animation";
import { fadeInUpAnimation } from "src/@fury/animations/fade-in-up.animation";
import { scaleInAnimation } from "src/@fury/animations/scale-in.animation";
import { ApiService } from "src/app/services/api.service";
import endpoints from "src/app/helpers/endpoints";
import { HttpErrorResponse, HttpResponse } from "@angular/common/http";
import { ErrorType } from "src/app/enums/error-type.enum";
import { Subject } from "rxjs";
import { takeUntil } from "rxjs/operators";
import { SelectionModel } from "@angular/cdk/collections";

@Component({
  selector: "fury-assign-status",
  templateUrl: "./assign-status.component.html",
  styleUrls: ["./assign-status.component.scss"],
  animations: [fadeInUpAnimation, fadeInRightAnimation, scaleInAnimation],
})
export class AssignStatusComponent implements OnInit, OnDestroy {
  statusTypeId: string = "";
  statusTypeName = "";
  ngUnSubscribe = new Subject<void>();
  selection = new SelectionModel<any>(true, []);
  itemList: any;
  assignedStatusList = [];
  constructor(
    private apiService: ApiService,
    private activatedRoute: ActivatedRoute,
    private router: Router,
  ) {}

  ngOnInit(): void {
    this.activatedRoute.params
      .pipe(takeUntil(this.ngUnSubscribe))
      .subscribe((res) => {
        if (res) {
          this.statusTypeId = res["statusTypeId"];
          if (this.statusTypeId) this.getClaimStatus();
        }
      });
    this.activatedRoute.queryParams
      .pipe(takeUntil(this.ngUnSubscribe))
      .subscribe((res: any) => {
        if (res?.statusType) this.statusTypeName = res?.statusType.replace(/-/g, " ");
      });
  }

  getClaimStatus() {
    this.apiService
      .get(endpoints.fileAClaim.claimStatus)
      .pipe(takeUntil(this.ngUnSubscribe))
      .subscribe({
        next: (res: HttpResponse<any>) => {
          if (res.body) {
            this.itemList = res.body?.data;
            this.getAllStatusByType();
          }
        },
        error: (err: HttpErrorResponse) => {
          this.apiService.alert(err.message, ErrorType.Error);
        },
      });
  }
  getAllStatusByType() {
    this.apiService
      .get(
        endpoints.settings.statusManagement.getAllStatusByType(this.statusTypeId) +"?page=1&size=999"
      )
      .pipe(takeUntil(this.ngUnSubscribe))
      .subscribe({
        next: (res: HttpResponse<any>) => {
          if (res?.body) {
            this.assignedStatusList = res.body?.claimStatuses?.data || [];
            // select exist Status items
            this.itemList?.forEach((val: any) => {
              if (this.assignedStatusList.some((element: any) => element?.emailTemplateActionStatusId === val["emailTemplateActionStatusId"])) {
                this.selection.select(val);
              }
            });
          }
        },
      });
  }
  assignClaimStatus() {
    const claimStatusIds = this.selection.selected.map(
      (item) => item?.emailTemplateActionStatusId
    );
    if (!claimStatusIds.length) {
      this.apiService.alert(
        "Please select minimum one status",
        ErrorType.Error
      );
      return;
    }
    this.apiService
      .patch(
        endpoints.settings.statusManagement.assignClaimStatus(
          this.statusTypeId
        ),
        { claimStatusIds }
      )
      .pipe(takeUntil(this.ngUnSubscribe))
      .subscribe({
        next: (res: HttpResponse<any>) => {
          if (res.body) {
            this.apiService.alert(res.body?.message, ErrorType.Success);
            this.redirectToStatusTypePage();
          }
        },
        error: (err: HttpErrorResponse) => {
          this.apiService.alert(err.message, ErrorType.Error);
        },
      });
  }
  redirectToStatusTypePage() {
    this.router.navigateByUrl("/settings/status/status-types");
  }
  redirectToUpdateStatusPage(item: any) {
    this.router.navigateByUrl(
      `/settings/status/edit-status/${item?.emailTemplateActionStatusId}`
    );
  }
  redirectToAddStatusPage() {
    this.router.navigateByUrl("/settings/status/add-status");
  }
  handleStatusChange(item: any) {
    this.selection.toggle(item);
  }

  ngOnDestroy(): void {
    this.ngUnSubscribe.next();
    this.ngUnSubscribe.complete();
  }
}
